import { ApiService } from '../apiService'

/** Mirrors BusinessVerificationStatus (AdventureCore.Domain.Enums.BusinessEnums). */
export enum BusinessVerificationStatus {
  Pending = 0,
  Verified = 1,
  Suspended = 2,
  Rejected = 3,
}

export const businessVerificationStatusLabel: Record<number, string> = {
  [BusinessVerificationStatus.Pending]: 'Pending',
  [BusinessVerificationStatus.Verified]: 'Verified',
  [BusinessVerificationStatus.Suspended]: 'Suspended',
  [BusinessVerificationStatus.Rejected]: 'Rejected',
}

/** Mirrors AdventureCore.Application.DTOs.Business.BusinessSummaryDto. */
export interface BusinessSummaryDto {
  id: string
  name: string
  slug: string
  tagline?: string | null
  description: string
  logo?: string | null
  verificationStatus: number
  isVerified: boolean
  createdAt: string
  primaryLocationSummary?: string | null
  locationCount: number
}

export interface BusinessSearchResult {
  items: BusinessSummaryDto[]
  totalCount: number
  page: number
  pageSize: number
}

export interface BusinessSearchParams {
  query?: string
  page?: number
  pageSize?: number
}

export const businessesApi = {
  // Admin businesses endpoint (AdminBusinessController): includes unverified.
  search: (params: BusinessSearchParams) =>
    ApiService.get<BusinessSearchResult>('/admin/businesses', params),
}
